<p-confirmDialog key="AddRole" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Static Data-->
<div class="Grid2ColMain">
	<label>Role Name:</label>
	<input [(ngModel)]="RoleName" class="form-control" type="text" />

	<label>Role Description:</label>
	<input [(ngModel)]="RoleDesc" class="form-control" type="text" />

	<label>User Level:</label>
	<select class="form-control" name="SelectedUserLevel" [(ngModel)]="SelectedUserLevel">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstUserLevels" [ngValue]="o.UserLevelID">
			{{ o.UserLevelDesc }}
		</option>
	</select>

	<label for="AllSchools">Available to all Schools:</label>
	<input id="AllSchools" [(ngModel)]="AllSchools" class="form-control" type="checkbox" />
</div>

<!--Application Items-->
<div class="TableWidth TopMargin">
	<caass-manage-application-items> </caass-manage-application-items>
</div>

<!--Reports-->
<div class="TableWidth TopMargin">
	<caass-manage-reports> </caass-manage-reports>
</div>

<!--Buttons-->
<div class="TopMargin TextCenter">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
